import React from 'react';
import './style.css'
import QRCode from "react-qr-code";
import { useSelector } from 'react-redux';
import { store } from '../../../redux/store';
import { setGoHome } from '../../../redux/slices/initLoad/types';
const Index = ({ showBack = true, showImageTop = true, showLamp = true,children, showLogo=true, showFooter=true, setShowListProduct, setShowSpecials, goHome, goCategories }) => {
   
  const [showModal, setShowModal] = React.useState(false);
  const [showBoost, setshowBoost] = React.useState(false);
  const [showModalPincode, setShowModalPincode] = React.useState(false);
  const [secret, setScret] = React.useState("");

  const handleButtonClick = () => {
    if (setShowListProduct) {
      setShowListProduct(false); 
    }
  };
  


   const {
      goHomeInit
   } = useSelector((state) => state.initLoad);


  const validScret = () => {

    if (secret === '') {
      alert('Debe ingresar el pin')
    }

    if (secret === "2355") {
       window.location.reload();
    } else {
       alert('Code invalid')
    }
    
  }
  
    return (
      <div className='backgroundlayout' style={{
        flex: 1,
        backgroundSize: 'cover',
        width: '100%',
        height: '100vh',
       
      }}>

        
        <div>
          {/*<button onClick={()=>setOpenNav(!openNav)} style={{...styles.iconMenuMobile, ...iconMenu}}>
            <Menu />
          </button>*/}
          

          <div className='contentChild' >

             {showImageTop && (
              <img
                 onContextMenu={(e) => e.preventDefault()}
                src={require('./assets/top.png')}
                style={{
                  pointerEvents: 'none',
                  width: '100%',
                  height: 150,
                  resizeMode: 'cover',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  zIndex:991,  
                }}
              />
            )}

            {showLamp && <img
               onContextMenu={(e) => e.preventDefault()}
                src={require('./assets/lamp.png')}
                style={{
                  width: 200,
                  height: 290,
                  pointerEvents: 'none',
                  resizeMode: 'contain',
                  position: 'absolute',
                  top: showImageTop ? -50 : 0,
                  left: 0,
                  zIndex: 10,
                }}
            />}
             

            {showImageTop && (
              <img
                onContextMenu={(e) => e.preventDefault()}
                src={require('./assets/lamp.png')}
                style={{
                  width: 200,
                  height: 290,
                   pointerEvents: 'none',
                  resizeMode: 'contain',
                  position: 'absolute',
                  top: 50,
                  right: -90,
                  zIndex: 100,
                }}
              />
        )}
            
              
               

            <div className='nav-menu-bar' style={{
              marginTop: showImageTop ? 40 : 0,
              width: '100%',
              position: 'relative'
            
            }}>

             
              {showLogo &&
              <div style={{
               
                paddingTop: 20,
                paddingBottom: 20,
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: showBack ? 'space-between':'center',
            
                }}>
                  
                  <div style={{ display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',}}>
                     {showBack && (
                        <div
                            onClick={()=>handleButtonClick()}
                                style={{
                                  width: 140,
                                  height: 52,
                                  display: 'flex',
                                  textAlign: 'center',
                                  alignItems: 'center',
                                  justifyContent: "center",
                                  cursor: 'pointer',
                                  marginLeft: 35,
                                  zIndex: 999,
                                  position: 'relative',
                                  background: "#fff",
                                  borderRadius: 10
                            }}>
                           
                              <p style={{position:'absolute', color: 'black', fontSize: 20, fontWeight: '900'}}>GO BACK</p>
                          </div>
                    )}

                  </div>
                  
                  <div style={{
                      alignItems: 'center',}}   >
                       <div style={{
                      
                        display: 'flex',
                          alignItems: 'center',
                              position: 'relative',
                              zIndex: 999,
                              justifyContent: 'end',}}>
                        <div onClick={()=>setShowModal('https://www.instagram.com/colombiansteakhouse/')} target='_blank'> <img
                        style={{
                          width: 28,
                            height: 28,
                            marginInline: 10
                        
                      }}
                      src={require('./assets/instagram.png')}
                      alt="Logo"
                      /> 
                      </div>

                      <div target='_blank' onClick={()=>setShowModal('https://www.facebook.com/colombianNJ/photos')}> 
                        <img
                          style={{
                              width: 28,
                                height: 28,
                                marginInline: 10
                        }}
                          src={require('./assets/facebook.png')}
                          alt="Logo"
                        /> 
                      </div>

                    

                      {/* <div target='_blank' onClick={()=>setShowModal('https://stanciaperuvianfusion.com/?fbclid=PAZXh0bgNhZW0CMTEAAabcJIytXY618p9SWTbgSUCDqZjeqqwDe6N-mVtvD2e3OsRHHxJ4b-C03sg_aem_ySjBYnYb0DeoIbZGrDsMbQ')}> 
                        <img
                          style={{
                              width: 30,
                                height: 30,
                                marginInline: 10
                        }}
                          src={require('./assets/web.png')}
                          alt="Logo"
                        /> 
                      </div>
                             */}
                  
                    <div>
                    
                    </div>
                      </div>
                  </div>

                 
              </div>
              }
              


            

            </div>
            {children}

            
            {showFooter &&
            <div
            style={{
              position: 'absolute',
              bottom: 0,
                  alignSelf: 'center',
                
                  width: '100%',
                  left: 0,
                  zIndex: 999
                
              
            }}>
            <div
              style={{
                paddingHorizontal: 40,
                paddingVertical: 15,
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                  marginTop: 5,
                gap: 20,
                    width: '100%',
                 
                
              }}>
              <div

                    onClick={() => {
                      //handleButtonClick()
                      //console.log('qlqlq')
                       store.dispatch(setGoHome(Math.random()));
                      //console.log({goHome})
                      
                  }}
                style={{
                   width: 210,
                  height: 70,
                  borderRadius: 9,
                  marginHorizontal: 10,
                    
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    
                    boxSizing: 'border-box'
                  }}>
                     <img   onContextMenu={(e) => e.preventDefault()} src={require('./assets/home.png')} style={{width: 170,  pointerEvents: 'none',height: 120, objectFit: 'contain', }}  />
                  </div>
                   <div

                    onClick={() => {
                      if (goCategories) {
                        goCategories(true)
                      }
                  }}
                    style={{
                  marginLeft: -20,
                  width: 210,
                  height: 70,
                  borderRadius: 9,
                    marginHorizontal: 10,
                    display: 'flex',
                    justifyContent: 'space-between',
                   
                    alignItems: 'center',
                    flexDirection: 'row',
                  
                   
                    boxSizing: 'border-box'
                  }}>
                  
                     <img onContextMenu={(e) => e.preventDefault()} src={require('./assets/cat.png')} style={{width: 210,pointerEvents: 'none', height: 60, objectFit: 'contain'}}  />
               
              </div>

              <div
                    onClick={() => {
                      if (setShowSpecials) {
                        setShowSpecials(true)
                      }
                }}
                style={{
                  width: 210,
                  height: 70,

                  borderRadius: 9,
                  marginHorizontal: 10,
                  justifyContent: 'space-between',
                 
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'row',
                 
                  
                    boxSizing: 'border-box',
                  }}>
                     <img onContextMenu={(e) => e.preventDefault()}  src={require('./assets/promo.png')} style={{width: 210, pointerEvents: 'none',height: 60, objectFit: 'contain'}}  />
             
                
              </div>
            </div>
            <div
              style={{
                zIndex: 100,
                flexDirection: 'row',
                justifyContent: 'space-around',
                paddingHorizontal: 20,
                paddingVertical: 5,
                  alignItems: 'center',
                marginTop: 20,
              }}>
                  <div
                    onClick={()=> setshowBoost(true)}
                style={{flexDirection: 'row', alignItems: 'center'}}>
                <p
                  style={{
                      color: '#fff',
                      fontWeight: '300',
                      textAlign: 'center',
                      fontSize: 14,
                    }}>
                 Powered by boostyourmenu.com V1.6
                </p>
              </div>
            </div>
          </div>
            }
            
            {showBoost &&
              <div onClick={ ()=> setshowBoost(false)} style={{ position: 'absolute', top: 0, bottom: 0, left: 0, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#00000063', zIndex: 9999, flexDirection: 'column' }}>
                <img
                 
                            style={{
                              width: 500,
                                height: 500,
                                marginInline: 10,
                                objectFit: 'contain',
                                zIndex: 9999
                            
                          }}
                          src={require('./assets/boost.png')}
                          alt="Logo"
                /> 
            
            </div>
            }
            

            {showModalPincode &&
              <div style={{ position: 'absolute', top: 0, bottom: 0, left: 0, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#00000063', zIndex: 9999, flexDirection: 'column' }}>
                
                <div style={{ position: 'absolute',background: '#fff', width: 500, height: 300, borderRadius: 30, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: "column" }}>
                  <img
                      onClick={()=>setShowModalPincode(false)}
                    style={{
                      position: 'absolute',
                      top: -10,
                      
                                width: 40,
                                  height: 40,
                                  marginInline: 10,
                                  objectFit: 'contain',
                                  position: 'absolute',
                                  right: -10,
                                  zIndex: 9999
                              
                            }}
                      src={require('./assets/close.png')}
                      alt="Logo"
                  /> 
                  <h4 style={{ color: '#F40000', fontSize: 40, fontWeight: 'bold', margin: 20 }}>PIN</h4>
                  <input type='number' style={{ width: 300, height: 40 }} onChange={(e) => {
                    setScret(e.target.value)
                  }} />
                  <br /><br />
                  
                  <div style={{display: 'flex', gap: 20}}>
                    <div onClick={() => setShowModalPincode(false)} style={{background: '#FF1616', width: 150, height: 50, justifyContent: 'center', alignItems: 'center', display: 'flex', borderRadius: 7}}>
                      <p style={{color: 'white', textTransform: 'uppercase', fontWeight: 'bold'}}>atras</p>
                    </div>
                    <div onClick={()=>validScret()} style={{ background: '#FF1616', width: 150, height: 50, justifyContent: 'center', alignItems: 'center', display: 'flex', borderRadius: 7 }}>
                      <p style={{color: 'white', textTransform: 'uppercase', fontWeight: 'bold'}}>Enviar</p>
                  </div>
                </div>
                </div>
              </div>
            }

            <img
                onClick={()=>setShowModalPincode(true)}
                        style={{
                          width: 40,
                            height: 40,
                            marginInline: 10,
                            objectFit: 'contain',
                            position: 'absolute',
                            bottom: -1,
                            right: 0,
                            zIndex: 9999
                        
                      }}
                src={require('./assets/pincode.png')}
                alt="Logo"
            /> 
            

            

            
            {showModal &&  <div onClick={()=>setShowModal(false)} style={{position: 'absolute', top: 0, bottom: 0, left: 0,width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#00000063', zIndex: 9999}}>
              <QRCode
              size={256}
              style={{ height: 400,  width: 400 }}
              value={showModal}
              divBox={`0 0 256 256`}
            />
            </div>}
           
          </div>
        </div>
      </div>
     
    );
  };

export default Index;